import * as React from "react"
import { motion } from "motion/react"
import type { LucideIcon } from "lucide-react"

interface KpiCardProps {
  label: string
  value: string | number
  change?: { value: number; label: string }
  icon: LucideIcon
  delay?: number
}

export function KpiCard({ label, value, change, icon: Icon, delay = 0 }: KpiCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay, ease: [0.25, 0.46, 0.45, 0.94] }}
      className="bg-[#111117] border border-[#1E1E2A] rounded-xl p-5 flex flex-col gap-3"
    >
      <div className="flex items-center justify-between">
        <span className="text-[11px] font-medium uppercase tracking-wider text-white/40 font-admin">
          {label}
        </span>
        <div className="w-8 h-8 rounded-lg bg-[#F37020]/10 flex items-center justify-center">
          <Icon className="w-4 h-4 text-[#F37020]" />
        </div>
      </div>
      <div className="flex items-end gap-2">
        <span className="text-2xl font-semibold text-white font-mono-admin tracking-tight">
          {typeof value === "number" ? value.toLocaleString() : value}
        </span>
        {change && (
          <span
            className={`text-xs font-medium mb-0.5 ${
              change.value >= 0 ? "text-emerald-400" : "text-red-400"
            }`}
          >
            {change.value >= 0 ? "+" : ""}
            {change.value} {change.label}
          </span>
        )}
      </div>
    </motion.div>
  )
}
